module.exports = __webpack_public_path__ + "media/images/SIDUVLOGO-f8cc6b79d7bb845210078f5ffac756d3.png";